import React from 'react';
import { Box, Flex, SimpleGrid, Stack, Text, Title } from '@mantine/core';

import Navbar from '../../components/navigation/Navbar';
import ModuleSelectionItem from '../../components/common/ModuleSelectionItem';
import Loader from '../../components/common/Loader';
import { ProtectedRoute } from '../../components/auth';
import { useAuth } from '../../context/AuthProvider';
import { useRoleModules } from '../../hooks/useRoleModules';
import { MODULE_DASHBOARD_GRID_CLASS } from '../../constants/navigation';

function Dashboard() {
    const { role } = useAuth();
    const modules = useRoleModules();

    if (!role) {
        return (
            <ProtectedRoute>
                <div className="h-screen w-screen relative overflow-y-hidden bg-[#f8f9fa] flex justify-center items-center">
                    <Loader size="lg" isPageLoader />
                </div>
                <Navbar />
            </ProtectedRoute>
        );
    }

    return (
        <ProtectedRoute>
            <div className="h-screen w-screen relative overflow-y-hidden bg-[#f8f9fa]">
                <div className="flex flex-col flex-1 relative top-16">
                    <Flex
                        justify="center"
                        align="center"
                        className="h-screen w-screen"
                    >
                        <Stack gap="xs">
                            <Title order={3}>Select a Module</Title>
                            <Box px="4px" py="6px" mb="300px">
                                {modules.length === 0 && (
                                    <Text
                                        size="sm"
                                        className="text-center text-gray-400"
                                    >
                                        You do not have access to any modules.
                                    </Text>
                                )}
                                <SimpleGrid
                                    cols={3}
                                    spacing="md"
                                    className={MODULE_DASHBOARD_GRID_CLASS}
                                >
                                    {modules.length > 0 &&
                                        modules.map(module => (
                                            <ModuleSelectionItem
                                                key={module.value}
                                                {...module}
                                            />
                                        ))}
                                </SimpleGrid>
                            </Box>
                        </Stack>
                    </Flex>
                </div>
            </div>
            <Navbar />
        </ProtectedRoute>
    );
}

export default Dashboard;
